import { change } from 'redux-form';
import axios from 'axios';
import {
  MOBILE_SETTINGS_UPLOAD_START,
  MOBILE_SETTINGS_UPLOAD_ERROR,
  MOBILE_SETTINGS_UPLOAD_SUCCESS,
} from '../../constants/index';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import {
  updateMobileSettingsMutation,
  updateToneMutation,
} from '../../lib/graphql';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import showErrorMessage from '../../helpers/showErrorMessage';
import { api } from '../../config';
import { demoRestriction } from '../demoRestriction';

export const updateMobileSettings = ({
  appForceUpdate,
  userAndroidVersion,
  userIosVersion,
  partnerAndroidVersion,
  partnerIosVersion,
  stripePublishableKey,
  allowableDistace,
  allowedServices,
  notificationInterval,
  sleepPartnerAndroid,
  sleepPartnerios,
  contactPhoneNumber,
  contactEmail,
  maximumEmergencyContact,
  duration,
  job,
  photo,
  description,
  estimatedPrice,
  location,
  requestTimeTone,
  isRequestTimerToneEnable,
  openAppOnRequest,
  requestToneFile,
  defaultScheduleInterval,
  addtionalWorkInterval,
  randomProviderSelection,
  preferredProviderSelection,
  maximumProviders,
  userAppAndroidMapAPIKey,
  serviceProviderAppAndroidMapAPIKey,
  userAppIosMapAPIKey,
  serviceProviderAppIosMapAPIKey,
  whatsApp,
  oneTimeVerification,
  oneTimeVerificationValue,
  deferredBackgroundCheck
}) => {
  try {
    return async (dispatch, getState, { client }) => {
      dispatch({ type: MOBILE_SETTINGS_UPLOAD_START });

      dispatch(setLoaderStart('MobileSettings'));

      const { data } = await client.mutate({
        mutation: updateMobileSettingsMutation,
        variables: {
          appForceUpdate,
          userAndroidVersion,
          userIosVersion,
          partnerAndroidVersion,
          partnerIosVersion,
          stripePublishableKey,
          allowableDistace,
          allowedServices,
          notificationInterval,
          sleepPartnerAndroid,
          sleepPartnerios,
          contactPhoneNumber,
          contactEmail,
          maximumEmergencyContact,
          duration,
          job,
          photo,
          description,
          estimatedPrice,
          location,
          requestTimeTone,
          isRequestTimerToneEnable,
          openAppOnRequest,
          requestToneFile,
          defaultScheduleInterval,
          addtionalWorkInterval,
          randomProviderSelection,
          preferredProviderSelection,
          maximumProviders,
          userAppAndroidMapAPIKey,
          serviceProviderAppAndroidMapAPIKey,
          userAppIosMapAPIKey,
          serviceProviderAppIosMapAPIKey,
          whatsApp,
          oneTimeVerification,
          oneTimeVerificationValue,
          deferredBackgroundCheck
        },
      });

      dispatch(setLoaderComplete('MobileSettings'));

      if (data?.updateMobileSettings?.status == 200) {
        dispatch({ type: MOBILE_SETTINGS_UPLOAD_SUCCESS });
        showToaster({
          messageId: 'mobileSettingsSuccess',
          toasterType: 'success',
        });
      } else {
        const errorMessage =
          data?.updateMobileSettings?.errorMessage ||
          (await showErrorMessage({ errorCode: 'invalidError' }));
        dispatch({ type: MOBILE_SETTINGS_UPLOAD_ERROR });
        showToaster({
          messageId: 'errorMessage',
          requestContent: errorMessage,
          toasterType: 'error',
        });
      }
    };
  } catch (error) {
    dispatch({ type: MOBILE_SETTINGS_UPLOAD_ERROR });
    showToaster({
      messageId: 'catchMessage',
      requestContent: error,
      toasterType: 'error',
    });
  }
};

export const deleteTone = fileName => async (
  dispatch,
  getState,
  { client },
) => {
  try {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    dispatch({
      type: MOBILE_SETTINGS_UPLOAD_START,
    });

    dispatch(change('MobileSettingsForm', 'requestTimeTone', null));

    const url = `${api.apiEndpoint}/deleteTone`;
    const response = await axios.post(
      url,
      { fileName },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    const { status } = await response?.data;

    if (status == 200) {
      const { data } = await client.mutate({
        mutation: updateToneMutation,
      });

      dispatch({
        type: MOBILE_SETTINGS_UPLOAD_SUCCESS,
      });
    } else {
      dispatch({
        type: MOBILE_SETTINGS_UPLOAD_ERROR,
      });
    }
  } catch (err) {
    dispatch({
      type: MOBILE_SETTINGS_UPLOAD_ERROR,
    });
    showToaster({
      messageId: 'catchMessage',
      requestContent: err,
      toasterType: 'error',
    });
    return true;
  }
};
